import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-020fd3f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "chart" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " USD a CPL ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "svg-container" }, null, -1))
const _hoisted_5 = { class: "buttons-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "button-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)))
        }, "Cerrar"),
        _createElementVNode("button", {
          class: "button-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.downloadExcel && $setup.downloadExcel(...args)))
        }, "Descargar en formato Excel")
      ])
    ])
  ]))
}